import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-335b595b")

_pushScopeId("data-v-335b595b")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Recupero password")
const _hoisted_2 = { class: "page_content" }
const _hoisted_3 = { class: "data_container" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "help_text" }, [
  /*#__PURE__*/_createTextVNode(" Tramite questa pagina è possibile procedere al recupero della propria password. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Inserisci l'email del tuo account e ti invieremo un codice di conferma da utilizzare successivamente. ")
], -1)
const _hoisted_5 = { class: "form_field_container ion-padding-horizontal" }
const _hoisted_6 = { class: "password_input" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Email", -1)
const _hoisted_8 = { class: "psw_container" }
const _hoisted_9 = {
  key: 0,
  class: "password_input"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Codice verifica", -1)
const _hoisted_11 = { class: "psw_container" }
const _hoisted_12 = {
  key: 1,
  class: "password_input"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Password", -1)
const _hoisted_14 = { class: "psw_container" }
const _hoisted_15 = {
  key: 2,
  class: "password_input"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Conferma password", -1)
const _hoisted_17 = { class: "psw_container" }
const _hoisted_18 = {
  key: 3,
  class: "change_password_container"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "change_password" }, "Invio email in corso", -1)
const _hoisted_20 = {
  key: 4,
  class: "change_password_container"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "change_password" }, "Modifica password in corso", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.arrowBackOutline,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("form", {
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.handleRecoveryPassword()), ["prevent"])),
                class: "form_container"
              }, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("div", _hoisted_8, [
                      _createVNode(_component_ion_input, {
                        type: "email",
                        modelValue: _ctx.userEmail,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.userEmail = $event)),
                        placeholder: "La tua email"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  (_ctx.isInputCodeVisible)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode("div", _hoisted_11, [
                          _createVNode(_component_ion_input, {
                            type: "text",
                            modelValue: _ctx.controlCode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.controlCode = $event)),
                            placeholder: "Codice ricevuto via email"
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isPasswordVisible)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode("div", _hoisted_14, [
                          _createVNode(_component_ion_input, {
                            type: "text",
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event)),
                            placeholder: "Nuova password"
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isPasswordVisible)
                    ? (_openBlock(), _createBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, [
                          _createVNode(_component_ion_input, {
                            type: "text",
                            modelValue: _ctx.passwordConfirm,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.passwordConfirm = $event)),
                            placeholder: "Conferma nuova password"
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loadingRequest)
                    ? (_openBlock(), _createBlock("div", _hoisted_18, [
                        _hoisted_19
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loadingRequestPassword)
                    ? (_openBlock(), _createBlock("div", _hoisted_20, [
                        _hoisted_21
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isFirstStepComplete)
                    ? (_openBlock(), _createBlock("button", {
                        key: 5,
                        type: "submit",
                        class: "btn_save_password",
                        disabled: _ctx.loadingRequest
                      }, " Ricevi email ", 8, ["disabled"]))
                    : (_openBlock(), _createBlock("button", {
                        key: 6,
                        type: "button",
                        class: "btn_save_password",
                        disabled: _ctx.loadingRequestPassword,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setPassword()))
                      }, " Imposta password ", 8, ["disabled"]))
                ])
              ], 32)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})